export default "__VITE_ASSET__k671hQJY__"